import React from 'react';
import { AppLayout } from '../components/layout/AppLayout';
import { ProfileList } from '../components/features/ProfileList';

export const ProfilePage: React.FC = () => {
  return (
    <AppLayout title="Мои данные">
      <ProfileList />
    </AppLayout>
  );
};
